export const getState = (state_name, states) => {
 // console.log("getstate", state_name, states);
  return states[state_name];
}

export const setState = (state_name, value, states) => {
  states[state_name] = value
  // console.log("setState", state_name, value, states);
  return value;
}